/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_SubtitleInputs */



/**
* | output |
* | --- |
* | "Platform-wide organizations, AI usage, and billing across all channels." |
*
* @param {Partner_Dashboard_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_subtitle = /** @type {((inputs?: Partner_Dashboard_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Plattformweite Organisationen, KI-Nutzung und Abrechnung über alle Kanäle.")
	return /** @type {LocalizedString} */ ("Platform-wide organizations, AI usage, and billing across all channels.")
});